import { type RouteRecordRaw } from 'vue-router';

export const meRoutes: RouteRecordRaw[] = [{
    path: 'me',
    name: 'me',
    redirect: { name: 'me.information' },
    meta: {
        hasTabs: true,
        code: 'core.routes.menu.me'
    },
    component: () => import('./views/MeView.vue'),
    children: [{
        path: 'information',
        name: 'me.information',
        meta: {
            showInTabs: true,
            index: 0,
            code: 'core.routes.me.information'
        },
        component: () => import('./views/me/InformationView.vue')
    }, {
        path: 'preferences',
        name: 'me.preferences',
        meta: {
            showInTabs: true,
            index: 1,
            code: 'core.routes.me.preferences'
        },
        component: () => import('./views/me/PreferencesView.vue')
    }, {
        path: 'password',
        name: 'me.password',
        meta: {
            showInTabs: true,
            index: 2,
            code: 'core.routes.me.password'
        },
        component: () => import('./views/me/PasswordView.vue')
    }]
}];